import type GradeSetsService from 'teacher-ui-client/services/grade-sets'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { service } from '@ember/service'
import RadioButtonGroup from 'teacher-ui-client/components/base/radio-button-group'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface Args {
  switchContentLevel: (value: string) => void
  selectedContentLevel: string
  contentLevelPositions: number[]
  useShortNames?: boolean
  disabled?: boolean
}

interface Signature {
  Args: Args
}

export class ContentLevelSelector extends Component<Signature> {
  @service gradeSets!: GradeSetsService

  get options() {
    const allOption = { text: 'All', value: 'all' }
    const options = this.args.contentLevelPositions.map((grade) => {
      const foundGrade = this.gradeSets.findByPosition(grade)
      return {
        text: this.args.useShortNames ? foundGrade?.name : foundGrade?.fullName,
        value: String(grade),
      }
    })
    return [allOption, ...options]
  }

  <template>
    <div class="flex items-center justify-center gap-2 print:hidden">
      <div>{{t "reporting.standardsPerformance.contentLevel"}}</div>
      <RadioButtonGroup
        class="inline-flex"
        @value={{@selectedContentLevel}}
        @buttons={{this.options}}
        @onSelect={{@switchContentLevel}}
        @disabled={{@disabled}}
      />
      <span><PhosphorIcon @icon="phosphor-info-fill" /><Tooltip
          @text={{t "reporting.tooltips.standardsPerformance.contentSelector"}}
        /></span>
    </div>
  </template>
}

export default ContentLevelSelector
